import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _values from "lodash/values";
import _mapValues from "lodash/mapValues";
import _set from "lodash/set";
import _reduce from "lodash/reduce";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useMemo } from 'react';
import { printPropDeprecationWarning, useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
/**
 * this is a local wrapper around `useDeprecatedPropsWarning`
 * with a less verbose interface.
 * all of these deprecations were made in the same version (8.10.0)
 */

var useDeprecatedProps = function useDeprecatedProps(_ref) {
  var props = _ref.props,
      warning = _ref.warning,
      componentName = _ref.componentName,
      version = _ref.version;
  useDeprecatedPropsWarning({
    component: componentName,
    props: props,
    deprecatedProps: Object.keys(props).map(function (propName) {
      return {
        deprecated: propName,
        migration: warning,
        version: version
      };
    })
  });
};
/**
 * legacy 'react-modal' npm package had an interface where:
 * ```jsx
 *  aria={{ labelledby: 'my-id', ... }}
 * ```
 * would be coverted to aria-<key> html attributes:
 * ```
 *  aria-labelledby="my-id" aria-...="..."
 * ```
 * - legacy interface: https://reactcommunity.org/react-modal/accessibility/#aria
 *
 * This function converts legacy aria prop interface
 * into spreadable object of aria html attributes
 */


var ariaAttributesFromLegacyInterface = function ariaAttributesFromLegacyInterface(_ref2) {
  var aria = _ref2.aria,
      contentLabel = _ref2.contentLabel;
  return _reduce(aria, function (memo, val, key) {
    _set(memo, "aria-".concat(key), val);

    return memo;
  }, {
    // contentLabel was the interface for aria-label in legacy third-party react-modal dependency
    'aria-label': contentLabel
  });
};
/**
 * legacy 'react-modal' npm package had an interface where
 * all various className props (className, overlayClassName, portalClassName, etc...)
 * were objects instead of strings:
 * ```jsx
 *  className={{
 *    base: 'my-classname-always-applied',
 *    afterOpen: 'my-classname-only-applied-when-visible',
 *    beforeClose: 'my-classname-only-applied-when-closing',
 *  }}
 * ```
 * - legacy-interface: https://reactcommunity.org/react-modal/
 *
 * This function warns if the deprecated interface is in use
 * and picks only the 'base' class from the className object
 * It returns a single string.
 */


var useDeprecatedClassNameProps = function useDeprecatedClassNameProps(_ref3) {
  var props = _ref3.props,
      warning = _ref3.warning,
      componentName = _ref3.componentName,
      version = _ref3.version;
  return useMemo(function () {
    return _mapValues(props, function (prop, propName) {
      if (!prop) return prop;
      if (typeof prop === 'string') return prop; // warn about deprecation

      if (process.env.NODE_ENV !== 'production') {
        var deprecatedProp = {
          version: version,
          deprecated: propName,
          migration: warning
        };
        printPropDeprecationWarning(componentName, [deprecatedProp], props);
      } // only take the base property


      return prop.base;
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [].concat(_toConsumableArray(_values(props)), [warning, componentName, version]));
};
/**
 * v8.10.0 of Modal/BaseModal changed the underlying dependency in use
 * It used to be the npm package 'react-modal', it change to npm package 'reakit'
 *
 * The legacy interface was a wide-open passthrough into the `react-modal` dependency's interface
 * This made it very complex, hard to reason about, and very difficult to maintain.
 *
 * This function normalizes the deprecated legacy 'react-modal' passthrough props with the current interface.
 * - it takes *all* props given to <Modal /> or <BaseModal />
 * - it warns when deprecated `react-modal` passthrough props are used
 * - it picks current interface props over deprecated props when both are provided
 * - it returns an object consisting of props for the current interface (ModalImpl)
 */


var useDeprecatedReactModalProps = function useDeprecatedReactModalProps(_ref4, componentName) {
  var animateMS = _ref4.animateMS,
      onOpen = _ref4.onOpen,
      className = _ref4.className,
      overlayClassName = _ref4.overlayClassName,
      closeTimeoutMS = _ref4.closeTimeoutMS,
      aria = _ref4.aria,
      contentLabel = _ref4.contentLabel,
      onAfterOpen = _ref4.onAfterOpen,
      props = _objectWithoutProperties(_ref4, ["animateMS", "onOpen", "className", "overlayClassName", "closeTimeoutMS", "aria", "contentLabel", "onAfterOpen"]);

  /* eslint-disable react-hooks/rules-of-hooks */
  if (process.env.NODE_ENV !== 'production') {
    // animateMS more clearly defines runtime behavior
    useDeprecatedProps({
      props: {
        closeTimeoutMS: closeTimeoutMS
      },
      warning: "Use 'animateMS' prop instead.",
      componentName: componentName,
      version: '8.10.0'
    }); // deprecated 'aria' prop is converted to individual 'aria-<attribute>' props

    useDeprecatedProps({
      props: {
        aria: aria
      },
      warning: "Instead use `aria-<attribute>` props directly, e.g. 'aria-label', 'aria-labelledby', 'aria-describedby', etc...",
      componentName: componentName,
      version: '8.10.0'
    });
    useDeprecatedProps({
      props: {
        contentLabel: contentLabel
      },
      warning: "Use 'aria-label' prop instead.",
      componentName: componentName,
      version: '8.10.0'
    }); // specific event handler names have been simplified to more clearyle describe runtime behavior

    useDeprecatedProps({
      props: {
        onAfterOpen: onAfterOpen
      },
      warning: "Please use 'onOpen' instead. Only 'onOpen' will be called if both 'onOpen' and 'onAfterOpen' are defined.",
      componentName: componentName,
      version: '8.10.0'
    });
  }
  /* eslint-enable react-hooks/rules-of-hooks */


  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, useDeprecatedClassNameProps({
    props: {
      className: className
    },
    warning: "Passing 'className' as an object with shape { base, afterOpen, beforeClose } has been deprecated. Only the 'className.base' be used. Please supply a single string instead of an object.",
    componentName: componentName,
    version: '8.10.0'
  })), useDeprecatedClassNameProps({
    props: {
      overlayClassName: overlayClassName
    },
    warning: "Passing 'overlayClassName' as an object with shape { base, afterOpen, beforeClose } has been deprecated. Only the 'className.base' be used. Please supply a single string instead of an object.",
    componentName: componentName,
    version: '8.10.0'
  })), {}, {
    // deprecated 'closeTimeoutMS' is fallback for 'animateMS' is
    animateMS: animateMS || closeTimeoutMS,
    // deprecated 'onAfterOpen' is fallback for 'onOpen'
    onOpen: onOpen || onAfterOpen
  }, ariaAttributesFromLegacyInterface({
    aria: aria,
    contentLabel: contentLabel
  })), props);
};

export default useDeprecatedReactModalProps;